// export const BASE_URL = 'https://api.midadworld.com';
// export const BASE_URL = 'http://beeserver:9090';
// export const BASE_URL = 'http://beeserver:8070';
export const BASE_URL = 'https://catalog-api.alwalaaingroup.com';
export const BYTE_RANGE_BASE_URL = BASE_URL + '/api/file-manager/stream';

export const INNER_VERSION = '1.20.0';
export const VERSION = '3.7.0';